export default __webpack_public_path__ + "static/media/atbs-background-desktop.f1478334.png";